import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from 'primereact/dialog';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Formik, Form } from 'formik';
import { Button } from 'primereact/button';
import { useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { validationMessages } from '../../../i18n/common';
import ConfirmForm from './ConfirmForm';

const i18n = defineMessages({
  header: {
    id: 'del_header.super_link',
    defaultMessage: 'Delete SuperLink',
  },
});

const SuperLinkDeleteFormModal = (props) => {
  const { reject, confirm, modalOpen } = props;

  const { formatMessage } = useIntl();
  const { superLinkId } = useParams();

  const validationSchema = Yup.object().shape({
    deleteMode: Yup.string().required(formatMessage(validationMessages.required)),
    confirmation_code: Yup.string().required(formatMessage(validationMessages.required)),
    re_confirmation_code: Yup.string()
      .oneOf([Yup.ref('confirmation_code'), null], validationMessages.sameAs)
      .required(formatMessage(validationMessages.required)),
  });

  const headerMessage = formatMessage(i18n.header);

  const initialValues = {
    confirmation_code: superLinkId,
  };

  const dialogFooter = (
    <>
      <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
        {(text) => <Button className="p-button-secondary" label={text} type="button" onClick={reject} />}
      </FormattedMessage>
      &nbsp;
      <FormattedMessage id="actions.delete" defaultMessage="Delete">
        {(text) => <Button label={text} type="submit" />}
      </FormattedMessage>
    </>
  );
  return (
    <Formik validationSchema={validationSchema} onSubmit={confirm} initialValues={initialValues}>
      {() => (
        <Form>
          <Dialog header={headerMessage} footer={dialogFooter} visible={modalOpen} onHide={reject} modal>
            <div className="panel panel-no-border">
              <div className="panel-body">
                <ConfirmForm />
              </div>
            </div>
          </Dialog>
        </Form>
      )}
    </Formik>
  );
};

SuperLinkDeleteFormModal.propTypes = {
  reject: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
};

export default SuperLinkDeleteFormModal;
